import { call, put } from 'redux-saga/effects';
import {
  loadChatUserIdPatientIdRequest,
  loadChatUserIdPatientIdError,
  loadChatUserIdPatientIdSuccess,
  updateMessageStatusApiCall,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* loadUserPatientChatWorker(action) {
  yield put(loadChatUserIdPatientIdRequest());
  const { patientId, offset } = action.payload.param;
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/conversation`,
      { offset, patientId, limit: 10, type: localStorage.getItem('tabSet') }
    );
    if (result) {
      yield put(loadChatUserIdPatientIdSuccess(result.data.data));
    } else {
      yield put(loadChatUserIdPatientIdError('Something went Wrong'));
    }
  } catch (e) {
    yield put(loadChatUserIdPatientIdError(e));
  }
}

export const loadUserPatientChat = (param) => ({
  type: SagaTypes.LOAD_OLD_CHAT,
  payload: { param },
});

export const updateMessageStatusSagaAction = (param) => ({
  type: SagaTypes.UPDATE_MESSAGE_STATUS_SAGA_TYPE,
  payload: { param },
});

export function* updateMessageStatusPatientSaga(action) {
  try {
    const userId = action.payload.param.userId;
    const messageId = action.payload.param.messageId;
    const result = yield call(
      Api.put,
      `${urls.aspariaBackend}api/v1/conversation/iHaveSeenTheConversation?`,
      { userId, messageId }
    );
    if (result) {
      yield put(updateMessageStatusApiCall('true'));
    } else {
      yield put(updateMessageStatusApiCall('false'));
    }
  } catch (error) {
    yield put(updateMessageStatusApiCall('false'));
  }
}
